<template>
  <div style="text-align:center; padding:40px 0;">
    <div style="width:280px; margin:0 auto;">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
        viewBox="0 0 474.1 513.1" style="enable-background:new 0 0 474.1 513.1;" xml:space="preserve">
      <g>
        <g>
          <g>
            <g>
              <path class="st0" d="M250.9,346.3l50.6,20.3l62.7-156l-42.8-17.2c-4.3-1.7-9.2,0.4-11,4.7L250.9,346.3z"/>
              <g>
                
                  <rect x="256.3" y="211.8" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 557.3027 610.9289)" class="st1" width="98.4" height="138.4"/>
                
                  <rect x="293.2" y="226.3" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 585.9085 505.214)" class="st2" width="44" height="1"/>
                
                  <rect x="284.4" y="223.9" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 587.2054 500.4001)" class="st2" width="62.4" height="1"/>
                
                  <rect x="275.5" y="236.6" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 580.538 525.1472)" class="st2" width="75.7" height="1"/>
                
                  <rect x="274.7" y="241.2" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 578.0779 534.2778)" class="st2" width="75.7" height="1"/>
                
                  <rect x="273" y="250.6" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 573.1579 552.5385)" class="st2" width="75.7" height="1"/>
                
                  <rect x="272.2" y="255.2" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 570.6979 561.6693)" class="st2" width="75.7" height="1"/>
                
                  <rect x="271.4" y="259.9" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 568.2379 570.7996)" class="st2" width="75.7" height="1"/>
                
                  <rect x="267.7" y="280.5" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 557.4178 610.9589)" class="st2" width="75.7" height="1"/>
                
                  <rect x="266.9" y="285.3" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 554.8667 620.4268)" class="st2" width="75.7" height="1"/>
                
                  <rect x="266" y="290.2" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 552.317 629.8937)" class="st2" width="75.7" height="1"/>
                
                  <rect x="265.1" y="295" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 549.7649 639.3625)" class="st2" width="75.7" height="1"/>
                
                  <rect x="264.3" y="299.9" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 547.2139 648.8303)" class="st2" width="75.7" height="1"/>
                
                  <rect x="263.4" y="304.7" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 544.6619 658.299)" class="st2" width="75.7" height="1"/>
                
                  <rect x="262.6" y="309.5" transform="matrix(-0.9846 -0.1746 0.1746 -0.9846 542.1111 667.7665)" class="st2" width="75.7" height="1"/>
              </g>
              <g>
                
                  <rect x="263.9" y="211.1" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 544.5368 630.9974)" class="st3" width="98.4" height="138.4"/>
                
                  <rect x="305.2" y="226.6" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 585.6945 530.0344)" class="st2" width="44" height="1"/>
                
                  <rect x="296.6" y="224.2" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 587.5629 525.4365)" class="st2" width="62.4" height="1"/>
                
                  <rect x="286.6" y="236.7" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 577.9562 549.0751)" class="st2" width="75.7" height="1"/>
                
                  <rect x="285.4" y="241.2" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 574.4119 557.7967)" class="st2" width="75.7" height="1"/>
                
                  <rect x="283" y="250.4" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 567.324 575.2385)" class="st2" width="75.7" height="1"/>
                
                  <rect x="281.8" y="255" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 563.7795 583.9603)" class="st2" width="75.7" height="1"/>
                
                  <rect x="280.6" y="259.6" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 560.2354 592.6814)" class="st2" width="75.7" height="1"/>
                
                  <rect x="275.3" y="279.8" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 544.6453 631.042)" class="st2" width="75.7" height="1"/>
                
                  <rect x="274" y="284.6" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 540.97 640.0856)" class="st2" width="75.7" height="1"/>
                
                  <rect x="272.8" y="289.3" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 537.2959 649.1287)" class="st2" width="75.7" height="1"/>
                
                  <rect x="271.5" y="294.1" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 533.6204 658.1724)" class="st2" width="75.7" height="1"/>
                
                  <rect x="270.3" y="298.8" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 529.9447 667.2164)" class="st2" width="75.7" height="1"/>
                
                  <rect x="269" y="303.6" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 526.2672 676.2615)" class="st2" width="75.7" height="1"/>
                
                  <rect x="267.8" y="308.4" transform="matrix(-0.9671 -0.2545 0.2545 -0.9671 522.5945 685.3035)" class="st2" width="75.7" height="1"/>
              </g>
              <path class="st4" d="M270.1,354L372,394.9l59.4-148l-85.6-52.8c-4.8-3-11.1-0.9-13.2,4.4L270.1,354z"/>
            </g>
            <g>
              <path class="st5" d="M108.9,252.4h-7c1.1-0.8,2.6-1.2,4.1-1.2h174.6c9.1,0,16.5,6.6,16.5,14.7v9.3c0,8.1-7.4,14.7-16.5,14.7
                L108,289.7L108.9,252.4z"/>
              <path class="st4" d="M282.5,275.1v-9.3c0-8.1-7.4-14.7-16.5-14.7h3.7c9.1,0,16.5,6.6,16.5,14.7v9.3c0,8.1-7.4,14.7-16.5,14.7
                l-3.7,0C275.1,289.8,282.5,283.2,282.5,275.1z"/>
              <path class="st4" d="M241.6,275.1v-9.3c0-8.1-7.4-14.7-16.5-14.7h3.7c9.1,0,16.5,6.6,16.5,14.7v9.3c0,8.1-7.4,14.7-16.5,14.7
                l-3.7,0C234.3,289.8,241.6,283.2,241.6,275.1z"/>
              <path class="st6" d="M208,251.2c8.7,0,15.8,6.3,15.8,14v10.5c0,7.7-7.1,14-15.8,14H99.3v-2.4h0.4l27.6-2.3l5.6-19.4
                c0,0-10.8-10.7-11.5-11c-0.7-0.3-21.7-1.1-21.7-1.1l-0.4,0v-2.3H208z"/>
              <path class="st3" d="M106.4,270.4c0-11.4-6.6-16.9-6.6-16.9h106c8,0,14.5,5.8,14.5,12.9v8.1c0,7.1-6.5,12.9-14.5,12.9h-106
                C99.8,287.4,106.4,284.7,106.4,270.4z"/>
              <path class="st3" d="M220.3,266.4v8.1c0,1.1-0.1,2.1-0.4,3.1c-3.6-7.8-10.4-15.2-23.5-17.6c-30.5-5.6-96.7-6.4-96.7-6.4h106
                C213.8,253.6,220.3,259.3,220.3,266.4z"/>
            </g>
            <g>
              <path class="st7" d="M111.8,329.6h-7.9c1.3-1,2.9-1.6,4.7-1.6h197.6c10.3,0,18.7,8.2,18.7,18.4v11.7c0,10.1-8.4,18.4-18.7,18.4
                l-195.4-0.1L111.8,329.6z"/>
              <path class="st2" d="M224,328.1c9.9,0,17.9,7.9,17.9,17.5v13.2c0,9.7-8,17.5-17.9,17.5h-123v-2.9h0.5l31.3-2.9l6.3-24.3
                c0,0-12.2-13.4-13-13.8c-0.8-0.3-24.6-1.4-24.6-1.4l-0.5,0v-2.9H224z"/>
              <path class="st3" d="M108.9,352.2c0-14.2-7.5-21.1-7.5-21.1h120c9.1,0,16.4,7.2,16.4,16.1v10.1c0,8.9-7.4,16.1-16.4,16.1h-120
                C101.4,373.4,108.9,370.1,108.9,352.2z"/>
              <path class="st3" d="M237.9,347.2v10.1c0,1.3-0.2,2.6-0.5,3.9c-4-9.7-11.8-19.1-26.6-22.1c-34.5-7-109.4-8.1-109.4-8.1h120
                C230.5,331.1,237.9,338.3,237.9,347.2z"/>
            </g>
            <g>
              <path class="st8" d="M331.4,290.9h7.9c-1.3-0.8-2.9-1.2-4.7-1.2H136.9c-10.3,0-18.7,6.5-18.7,14.6v9.2c0,8,8.4,14.6,18.7,14.6
                l195.5-0.1L331.4,290.9z"/>
              <path class="st9" d="M219.1,289.7c-9.9,0-17.9,6.2-17.9,13.9v10.5c0,7.7,8,13.9,17.9,13.9h123.1v-2.3h-0.5l-31.3-2.3l-6.3-19.3
                c0,0,12.2-10.7,13-10.9c0.8-0.3,24.6-1.1,24.6-1.1l0.5,0v-2.3H219.1z"/>
              <path class="st3" d="M334.2,308.8c0-11.3,7.5-16.7,7.5-16.7h-120c-9.1,0-16.4,5.7-16.4,12.8v8c0,7.1,7.4,12.8,16.4,12.8h120
                C341.7,325.7,334.2,323,334.2,308.8z"/>
              <path class="st3" d="M205.2,304.9v8c0,1.1,0.2,2.1,0.5,3.1c4-7.7,11.8-15.1,26.6-17.5c34.5-5.6,109.4-6.4,109.4-6.4h-120
                C212.6,292.1,205.2,297.8,205.2,304.9z"/>
              <path class="st10" d="M154.4,313.5v-9.2c0-8,8.4-14.6,18.7-14.6h-18.8c-10.3,0-18.7,6.5-18.7,14.6v9.2c0,8,8.4,14.6,18.7,14.6
                l18.5,0C162.7,328,154.4,321.5,154.4,313.5z"/>
            </g>
            <path class="st4" d="M344.4,377.9h9.9c-1.6-0.9-3.6-1.4-5.8-1.4H100.6c-13,0-23.5,7.3-23.5,16.3v10.3c0,9,10.5,16.3,23.5,16.3
              l245-0.1L344.4,377.9z"/>
            <path class="st0" d="M203.7,376.6c-12.4,0-22.5,7-22.5,15.6v11.7c0,8.6,10.1,15.6,22.5,15.6H358v-2.6h-0.6l-39.2-2.6l-7.9-21.6
              c0,0,15.3-11.9,16.3-12.2c1-0.3,30.8-1.2,30.8-1.2l0.6,0v-2.6H203.7z"/>
            <path class="st3" d="M348,397.9c0-12.6,9.4-18.7,9.4-18.7H206.9c-11.4,0-20.6,6.4-20.6,14.3v9c0,7.9,9.2,14.3,20.6,14.3h150.5
              C357.4,416.7,348,413.8,348,397.9z"/>
            <path class="st3" d="M186.2,393.5v9c0,1.2,0.2,2.3,0.6,3.4c5.1-8.6,14.8-16.9,33.3-19.6c43.2-6.2,137.2-7.1,137.2-7.1H206.9
              C195.5,379.2,186.2,385.6,186.2,393.5z"/>
            <path class="st11" d="M50.4,423.8h358.5c1.3,0,2.4-1.1,2.4-2.4v0c0-1.3-1.1-2.4-2.4-2.4H50.4c-1.3,0-2.4,1.1-2.4,2.4l0,0
              C48,422.8,49.1,423.8,50.4,423.8z"/>
            <polygon class="st0" points="413.4,263.3 344,223.6 334.7,242.2 405.7,279.7 			"/>
            <path class="st8" d="M356.4,119.9c0,0,0.5,5.4,4.8,5.8c-4.3,0.4-4.8,5.8-4.8,5.8s-0.5-5.4-4.8-5.8
              C355.9,125.3,356.4,119.9,356.4,119.9z"/>
            <path class="st6" d="M431.5,277.2c0,0,0.8,8.1,7.2,8.7c-6.4,0.6-7.2,8.7-7.2,8.7s-0.8-8.1-7.2-8.7
              C430.7,285.3,431.5,277.2,431.5,277.2z"/>
            <path class="st4" d="M411.5,75.7c0,0,0.7,7.2,6.4,7.7c-5.7,0.5-6.4,7.7-6.4,7.7s-0.7-7.2-6.4-7.7
              C410.7,82.9,411.5,75.7,411.5,75.7z"/>
            <path class="st4" d="M73.9,309c0,0,0.5,4.8,4.3,5.2c-3.8,0.3-4.3,5.2-4.3,5.2s-0.5-4.8-4.3-5.2C73.4,313.9,73.9,309,73.9,309z"/>
            <path class="st6" d="M386,173.1c0,0,0.5,4.8,4.3,5.2c-3.8,0.3-4.3,5.2-4.3,5.2s-0.5-4.8-4.3-5.2C385.5,177.9,386,173.1,386,173.1
              z"/>
            <path class="st6" d="M319.7,46.4c0,0,0.5,4.8,4.3,5.2c-3.8,0.3-4.3,5.2-4.3,5.2s-0.5-4.8-4.3-5.2
              C319.2,51.2,319.7,46.4,319.7,46.4z"/>
            <path class="st6" d="M120,107.8c0,0,0.6,6.3,5.6,6.8c-5,0.4-5.6,6.8-5.6,6.8s-0.6-6.3-5.6-6.8C119.4,114.2,120,107.8,120,107.8z"
              />
            <path class="st6" d="M77.1,217.2c0,0,0.9,9.3,8.2,9.9c-7.3,0.6-8.2,9.9-8.2,9.9s-0.9-9.3-8.2-9.9
              C76.2,226.5,77.1,217.2,77.1,217.2z"/>
            <path class="st6" d="M300.4,133.2c0,0,0.7,7.2,6.4,7.7c-5.7,0.5-6.4,7.7-6.4,7.7s-0.7-7.2-6.4-7.7
              C299.7,140.4,300.4,133.2,300.4,133.2z"/>
            <path class="st8" d="M437.9,210.8c0,0,0.7,7.2,6.4,7.7c-5.7,0.5-6.4,7.7-6.4,7.7s-0.7-7.2-6.4-7.7
              C437.2,217.9,437.9,210.8,437.9,210.8z"/>
            <path class="st8" d="M81.7,63.3c0,0,0.5,5.1,4.6,5.5c-4,0.4-4.6,5.5-4.6,5.5s-0.5-5.1-4.6-5.5C81.2,68.4,81.7,63.3,81.7,63.3z"/>
            <path class="st8" d="M135.6,189.8c0,0,0.8,8.2,7.3,8.8c-6.5,0.6-7.3,8.8-7.3,8.8s-0.8-8.2-7.3-8.8
              C134.8,198,135.6,189.8,135.6,189.8z"/>
            <path class="st4" d="M63.9,136.4c0,0,0.6,6.5,5,7c-4.4,0.4-5,7-5,7s-0.6-6.5-5-7C63.3,143,63.9,136.4,63.9,136.4z"/>
            <path class="st4" d="M169.7,32.5c0,0,0.6,6.5,5,7c-4.4,0.5-5,7-5,7s-0.6-6.5-5-7C169.1,39,169.7,32.5,169.7,32.5z"/>
            <g>
              <g>
                <path class="st3" d="M239.7,163.4l11.2,0.9l-3.6,9.1l-5.7-0.5l-2.4,7.5c-0.6-0.3-1-0.5-1.1-0.5c-0.2-0.1-0.8-3.9-1.3-7.4
                  L239.7,163.4z"/>
                <path class="st5" d="M246.1,246.7v3.9c0,0.3,0.3,0.6,0.6,0.6h9.2c0.7,0,0.9-0.9,0.4-1.2l-5.2-3.3
                  C251.1,246.7,249.1,248.2,246.1,246.7z"/>
                <path class="st12" d="M228,79.4c-0.1,0.1-0.3-0.1-0.2-0.2c0.2-1.1,0.9-4.5,0.7-4.7c-0.3-0.1-1,2.9-1.3,3c-0.3,0,0.4-2.9,0.1-3
                  c-0.4-0.1-1,2.6-1.1,2.6c-0.2,0,0.1-2.7,0-2.9c-0.2-0.2-0.8,2.6-1,2.7c-0.2,0.1-0.4-2-0.6-2c-0.2,0-0.3,0-1.2,4.8
                  c0,0-0.1,1.8-0.4,2.2l0.7,1.4l2.2,0.1c0,0,4.7-4.3,4.7-4.5C230.3,78.6,230.1,78.6,228,79.4z"/>
                <path class="st12" d="M250.4,80.5c0.1,0.1,0.3,0.1,0.3-0.1c0.3-1.1,1.2-4.5,1.5-4.5c0.3,0-0.4,3.1-0.2,3.2
                  c0.3,0.2,0.9-2.8,1.3-2.7c0.4,0.1-0.3,2.8-0.2,2.9c0.1,0.1,1.1-2.4,1.3-2.5c0.2-0.1-0.5,2.7-0.3,2.9c0.1,0.2,1.3-1.6,1.4-1.6
                  c0.2,0.1,0.3,0.1-1.1,4.9c0,0-0.8,1.6-0.7,2.1l-1.3,1l-2-0.9c0,0-2.3-6-2.1-6.2C248.7,78.8,248.9,78.8,250.4,80.5z"/>
                <polygon class="st12" points="233.1,119.4 233.2,127.7 225.1,126.4 226.5,117.1 					"/>
                <path class="st13" d="M225.8,121.4l0.6-4.3l6.7,3.1l0,1.6C231.5,122.2,228.5,122.6,225.8,121.4z"/>
                <path class="st5" d="M218.6,246.2v4.3c0,0.4-0.3,0.6-0.6,0.6h-10.1c-0.7,0-1-1-0.4-1.4l5.7-3.6
                  C213.1,246.2,215.3,247.9,218.6,246.2z"/>
                <g>
                  <g>
                    <g>
                      <path class="st7" d="M209.3,172.7c0-0.9-2.4,1.8-2.3,1.1c0.9-15.4,31-2.5,31-2.5l7.3,5.4l8.3,71.2c0,0-4.5,1.3-7.4,0.2
                        l-18.3-61l-2.3-0.9C225.5,186.2,215.5,179.2,209.3,172.7z"/>
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <path class="st9" d="M206.9,174.4c0,0.2,0,0.4,0,0.6C206.9,174.7,206.9,174.6,206.9,174.4z"/>
                    </g>
                    <g>
                      <path class="st9" d="M206.9,174.9c0,0.2,0,0.4,0,0.6C206.9,175.3,206.9,175.1,206.9,174.9z"/>
                    </g>
                    <g>
                      <path class="st9" d="M206.9,175.6c0,0.2,0,0.4,0,0.6C206.9,176,206.9,175.8,206.9,175.6z"/>
                    </g>
                    <g>
                      <path class="st9" d="M207,173.8c0,0.2,0,0.3,0,0.5C206.9,174.1,207,173.9,207,173.8z"/>
                    </g>
                    <g>
                      <path class="st7" d="M207,170.3c6.2,6.5,18.6,15.9,18.6,15.9l2.3,0.9l-2.3-0.9l-7,61.7c0,0-5,0.9-7.8-0.6
                        C210.7,247.3,206.6,188.6,207,170.3z"/>
                    </g>
                    <g>
                      <path class="st9" d="M253.5,247.9c0,0-1.9,0.6-4.1,0.6C251.6,248.4,253.5,247.9,253.5,247.9L253.5,247.9z"/>
                    </g>
                    <g>
                      <path class="st9" d="M247,248.4c0.2,0,0.4,0.1,0.6,0.1C247.4,248.4,247.2,248.4,247,248.4z"/>
                    </g>
                    <g>
                      <path class="st9" d="M249.4,248.5c-0.5,0-1,0-1.6,0C248.4,248.5,248.9,248.5,249.4,248.5z"/>
                    </g>
                  </g>
                </g>
                <path class="st14" d="M245.3,176.6l1.2,10.2c-3.1,1.2-10.7,2.5-16.5-10.1c-1.8-4-2.3-6.8-1.9-8.9c5.5,1.5,9.9,3.4,9.9,3.4
                  L245.3,176.6z"/>
                <path class="st3" d="M217.7,135.2c0.3,0,5.5-11.8,5.5-11.8c4.4,3.1,10.5,1,10.5,1s24.3,44.5,8,51.4
                  c-16.3,6.9-31.7-1.5-31.7-1.5s-3.5-9-3.5-9.4C206.6,164.5,217.4,135.2,217.7,135.2z"/>
                <path class="st2" d="M249.4,85.2c0,0,1.1,21.1-0.9,25c-6.6,12.8-14.7,14.1-14.7,14.1s-2.8,44.9-0.5,55.6c0,0,7.7,2.4,19-2.9
                  c0,0-8.7-34.8-8.2-39.2c0,0,13.9-12.4,14.3-26.9c0.5-14.6-3.4-27.5-3.4-27.5L249.4,85.2z"/>
                <path class="st2" d="M212,178.3c0,0,0.9-16.7,4.7-32.5c3.8-15.8,6.6-22.4,6.6-22.4c-5.1-5.6-4.3-10.7-3.8-17.3
                  c0.5-7.6,8-22.9,8-22.9l-5-3.3c-24.1,29-10.7,52-10.7,52s-9,31.9-10.2,41.6C201.4,173.5,206.2,176.2,212,178.3z"/>
                <path class="st15" d="M243.8,137.8c-0.3-0.2-0.6-0.5-1-0.9c-1-1.2-1.6-2.6-1.9-4.2c0.2,0.7,0.8,2.6,2.1,4.1
                  c0.6,0.6,0.9,0.9,1.1,1c0,0-0.1,0.1-0.1,0.1c0,0,0,0.1,0,0.1c-0.3,0.1-0.9,0.1-1.8-0.4c-0.6-0.3-1.1-0.7-1.5-1.1
                  c0.3,0.2,1,0.7,1.6,1C242.7,137.6,243.3,137.8,243.8,137.8z"/>
                <path class="st15" d="M211.8,131.8c0.4-0.3,0.8-0.6,1.1-1c1-1.2,1.6-2.6,2.1-4.1c-0.4,1.5-0.9,2.9-1.9,4.2
                  c-0.3,0.4-0.7,0.7-1,0.9c0.2,0,0.5,0,0.7-0.1c0.3-0.1,0.6-0.2,0.9-0.3c0.6-0.3,1.2-0.7,1.6-1c-0.4,0.4-0.9,0.8-1.5,1.1
                  c-0.3,0.2-0.6,0.3-0.9,0.4c-0.3,0.1-0.6,0.1-1,0.1l-0.2,0L211.8,131.8z"/>
                <polygon class="st7" points="221.6,102.4 221.1,108.1 222,108.7 223.6,101.7 					"/>
                <path class="st16" d="M222.8,107.5c0.2,1.3-0.4,2.5-1.4,2.7c-1,0.2-2.1-0.7-2.3-2c-0.2-1.3,0.4-2.5,1.4-2.7
                  C221.5,105.4,222.5,106.2,222.8,107.5z"/>
                <path class="st12" d="M221.3,112.8c-0.3-1.7-0.2-3.3-0.1-4.8c0-0.3,0-0.6,0.1-0.9c0-1.3,0.3-2.6,0.8-3.8
                  c1.8-4.1,6.1-6.6,10.5-6c6,0.7,9.9,6.4,8.8,12.1c0.7-0.2,1.4-0.2,2,0.2c1.1,0.8,1.2,2.5,0.2,3.8c-1,1.3-2.6,1.8-3.7,1.1
                  c-0.1-0.1-0.3-0.2-0.4-0.4c-1.5,4.8-6.2,7.8-11,6.7C224.9,120,221.9,117,221.3,112.8z"/>
                <path class="st17" d="M232.3,108.2c-0.2,0.6,0.2,1.2,0.8,1.2c0.4,0,0.7-0.2,0.8-0.6c0.2-0.6-0.2-1.2-0.8-1.2
                  C232.8,107.7,232.5,107.9,232.3,108.2z"/>
                <path class="st17" d="M224.8,107.1c-0.2,0.6,0.2,1.2,0.8,1.2c0.4,0,0.7-0.2,0.8-0.6c0.2-0.6-0.2-1.2-0.8-1.2
                  C225.2,106.6,224.9,106.8,224.8,107.1z"/>
                <path class="st16" d="M231.2,114.5c-0.5,0.2-1,0.4-1.4,0.5c-0.5,0.1-1,0.1-1.5,0.1c-0.5-0.1-1-0.2-1.4-0.5
                  c-0.4-0.3-0.8-0.6-1.2-1c0.4,0.5,0.7,0.8,1.1,1.1c0.4,0.3,0.9,0.5,1.4,0.5c0.5,0.1,1,0,1.5-0.1
                  C230.3,114.9,230.7,114.7,231.2,114.5z"/>
                <path class="st7" d="M231.6,106.4c0.5-0.1,0.9-0.1,1.3-0.1c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.8,0.3,1.1,0.5
                  c0.5,0.3,0.8,0.6,1.1,0.8c-0.2-0.4-0.4-0.9-0.8-1.2c-0.3-0.3-0.8-0.6-1.3-0.7c-0.5-0.1-1-0.1-1.5,0
                  C232.4,105.9,232,106.1,231.6,106.4z"/>
                <path class="st7" d="M228.1,105.9c-0.2-0.4-0.6-0.8-1-1c-0.4-0.3-0.9-0.4-1.4-0.4c-0.5,0-1,0-1.4,0.3c-0.4,0.2-0.8,0.5-1.1,0.9
                  c0.3-0.1,0.7-0.3,1.3-0.4c0.4-0.1,0.8-0.1,1.2-0.1c0.4,0,0.8,0.1,1.2,0.3C227.3,105.4,227.7,105.6,228.1,105.9z"/>
                <path class="st16" d="M229.6,107c-0.4,0.4-0.8,0.8-1.2,1.3c-0.4,0.4-0.7,0.9-1,1.4c-0.2,0.3-0.4,0.7-0.4,1c0,0.2,0,0.4,0.3,0.7
                  c0.2,0.2,0.4,0.4,0.7,0.6c0.2,0.2,0.5,0.3,0.7,0.4c-0.4-0.4-0.9-0.7-1.2-1.2c-0.1-0.1-0.2-0.2-0.2-0.3c0-0.1,0-0.2,0.1-0.3
                  c0.1-0.2,0.2-0.5,0.4-0.7c0.3-0.5,0.6-0.9,0.9-1.4C229,107.9,229.3,107.5,229.6,107z"/>
                <path class="st7" d="M222.6,96.3c0,0-3-0.6,0.7-2.4c3.7-1.8,12.7-2.9,17.5,1.2c0,0,1.6-2,3-1.1c1.4,0.9-1.5,1.9-1.5,1.9
                  s2,0.4,2.4,1.5c0.3,0.8-0.9,0.6-1.6,0.4c1.1,0.4,4.3,3.5,0.1,11.7c-0.7-0.3-5.5-7.1-5.5-7.1s-9.5,3.1-7.8,0.5
                  c0,0-11.1,2.8-8.4-2.2C221.5,100.6,217.5,100,222.6,96.3z"/>
                <path class="st7" d="M243.2,109.5c0,0-0.7-0.6-1.8-0.1c-1.1,0.4-1.8,2.9-1.8,2.9s-3.6,2.9-1.8-9.9c1.7-12.6,4.1,2.1,4.1,2.1
                  L243.2,109.5z"/>
              </g>
            </g>
            <g>
              <path class="st4" d="M248.5,70L232,68.8c-0.8-0.1-1.5-0.8-1.4-1.6l0,0c0.1-0.8,0.8-1.5,1.6-1.4l16.4,1.2
                c0.8,0.1,1.5,0.8,1.4,1.6l0,0C250,69.4,249.3,70,248.5,70z"/>
              <polygon class="st4" points="243.7,20.5 249.5,34.5 264.4,37.8 252.7,47.6 254.2,62.8 241.3,54.7 227.4,60.8 231,46.1 
                220.9,34.7 236.1,33.6 				"/>
              <g>
                <g>
                  <polygon class="st0" points="243.7,20.5 242.3,41.1 249.5,34.5 						"/>
                  <polygon class="st0" points="264.4,37.8 242.3,41.1 252.7,47.6 						"/>
                  <polygon class="st0" points="242.3,41.1 236.1,33.6 220.9,34.7 						"/>
                  <polygon class="st0" points="227.4,60.8 242.3,41.1 231,46.1 						"/>
                  <polygon class="st0" points="254.2,62.8 242.3,41.1 241.3,54.7 						"/>
                </g>
              </g>
              
                <rect x="227.4" y="69.7" transform="matrix(0.9975 7.106841e-02 -7.106841e-02 0.9975 5.8735 -16.8635)" class="st18" width="25.1" height="8.8"/>
              
                <rect x="239.2" y="65.5" transform="matrix(7.104567e-02 -0.9975 0.9975 7.104567e-02 144.7948 311.5159)" class="st19" width="1" height="25.1"/>
              
                <rect x="239.7" y="57.4" transform="matrix(7.104748e-02 -0.9975 0.9975 7.104748e-02 153.3778 304.5929)" class="st19" width="1" height="25.1"/>
              <path class="st0" d="M252.5,71l-24.6-1.8c-0.6,0-1.1-0.6-1-1.2l0,0c0-0.6,0.6-1.1,1.2-1l24.6,1.8c0.6,0,1.1,0.6,1,1.2l0,0
                C253.7,70.6,253.1,71.1,252.5,71z"/>
              <path class="st18" d="M252.4,81.5l-26.3-1.9c-0.2,0-0.3-0.2-0.3-0.3l0.1-1.6c0-0.2,0.2-0.3,0.3-0.3l26.3,1.9
                c0.2,0,0.3,0.2,0.3,0.3l-0.1,1.6C252.7,81.3,252.6,81.5,252.4,81.5z"/>
              <path class="st4" d="M244.4,76.5l-9.5-0.7c-1.2-0.1-2.1-1.1-2-2.3l0,0c0.1-1.2,1.1-2.1,2.3-2l9.5,0.7c1.2,0.1,2.1,1.1,2,2.3l0,0
                C246.6,75.7,245.6,76.6,244.4,76.5z"/>
              <path class="st20" d="M235,75.1c-0.8-0.1-1.5-0.8-1.3-1.7c0.1-0.7,0.8-1.2,1.6-1.1l9.4,0.7c0.7,0.1,1.4,0.6,1.4,1.4
                c0,0.9-0.7,1.6-1.5,1.5L235,75.1z"/>
              <path class="st4" d="M243.1,67.5l-5.3-0.4l0-0.5c0.1-2,0.4-6.1,3.5-11.9l0,0c2.4,6.6,1.9,10.3,1.8,12.3L243.1,67.5z"/>
            </g>
          </g>
        </g>
        <g>
          <circle class="st21" cx="327.8" cy="338.5" r="80"/>
          <path class="st15" d="M382.9,304.2L382.9,304.2c-3.3-3.3-8.8-3.3-12.1,0l-58.6,58.6l-19.8-19.8c-3.3-3.3-8.8-3.3-12.1,0l0,0
            c-3.3,3.3-3.3,8.8,0,12.1l24,24c0.4,0.7,0.9,1.4,1.5,2l0,0c3.3,3.3,8.8,3.3,12.1,0l65-65C386.3,313,386.3,307.5,382.9,304.2z"/>
        </g>
        <g>
          <path class="st21" d="M114.7,463.2l-5,8c-3.4-2.3-7.3-3.5-11.8-3.5c-2.6,0-3.9,0.3-4.1,0.8c1.6,0.4,3.9,0.9,6.8,1.6
            c9.3,2.6,14,7.3,14,14.1c0,3.6-1.7,6.4-5.1,8.4c-2.7,1.6-6,2.5-9.7,2.5c-6.5,0-13-2.1-19.4-6.3l5.3-9.3c5.1,3.3,9.8,4.9,14.1,4.9
            c2.3,0,3.4-0.3,3.4-0.8c0-1.1-1.7-2-5.1-2.8c-5.2-1.3-8.6-2.3-10.3-3.2c-3.6-1.9-5.4-4.8-5.4-8.5c0-4.1,1.8-7.2,5.3-9.2
            c2.8-1.6,6.4-2.3,10.8-2.3C105,457.6,110.5,459.4,114.7,463.2z"/>
          <path class="st21" d="M167.1,492.8c-2.6,0.6-6.5,1.4-11.6,2.3c-0.6-1.9-1-3.5-1.3-4.8c-4.5,3.1-9.7,4.7-15.4,4.7
            c-6.1,0-10.9-1.6-14.4-4.9c-3.5-3.2-5.2-7.9-5.2-13.9c0-7,2.5-13.2,7.5-18.7l9.9,5.1c-4.3,4.9-6.4,9.6-6.4,14.2
            c0,4.9,2.7,7.3,8,7.3c7.7,0,12.8-5.5,15.5-16.6c0.7-2.8,1.5-6.1,2.3-9.9l11,3c-1.4,5.9-2,12.1-2,18.6
            C164.8,485.3,165.5,489.7,167.1,492.8z"/>
          <path class="st21" d="M210.6,487c-6.7,5.4-13.1,8-19.2,8c-5.5,0-10.2-1.6-14.2-4.8c-4.3-3.4-6.5-7.8-6.5-13.2
            c0-5.9,2.1-10.7,6.2-14.2c3.9-3.4,8.8-5.1,14.8-5.1c7.1,0,12.8,2.4,17.1,7.3l-7.2,7.3c-3.1-2.5-6.4-3.8-10-3.8
            c-2.6,0-4.9,0.7-6.8,2c-2.1,1.5-3.1,3.6-3.1,6.1c0,2.3,1,4.3,2.9,5.8c1.8,1.4,3.9,2.1,6.3,2.1c4.6,0,8.8-1.9,12.8-5.6L210.6,487z"
            />
          <path class="st21" d="M253.3,487c-6.7,5.4-13.1,8-19.2,8c-5.5,0-10.2-1.6-14.2-4.8c-4.3-3.4-6.5-7.8-6.5-13.2
            c0-5.9,2.1-10.7,6.2-14.2c3.9-3.4,8.8-5.1,14.8-5.1c7.1,0,12.8,2.4,17.1,7.3l-7.2,7.3c-3.1-2.5-6.4-3.8-10-3.8
            c-2.6,0-4.9,0.7-6.8,2c-2.1,1.5-3.1,3.6-3.1,6.1c0,2.3,1,4.3,2.9,5.8c1.8,1.4,3.9,2.1,6.3,2.1c4.6,0,8.8-1.9,12.8-5.6L253.3,487z"
            />
          <path class="st21" d="M298.6,474.4c0,3.1-0.9,5.5-2.6,7.3c-1.8,1.8-4.3,2.7-7.4,2.7c-3.9,0-11.1-1.4-21.5-4.2
            c3.1,3.1,8,4.7,14.5,4.7l-1,10.2c-7.8,0-13.6-1.3-17.5-3.9c-4.7-3-7-8.1-7-15.4c0-5.3,2.3-9.7,6.9-13.2c4.2-3.2,9-4.9,14.4-4.9
            c5.3,0,10,1.4,14.1,4.2C296.3,465,298.6,469.2,298.6,474.4z M287.8,473.7c0-1.6-1.1-3-3.2-4c-1.8-0.8-3.7-1.2-5.6-1.2
            c-3.5,0-6.4,1-8.9,3c9.4,2.3,14.9,3.5,16.6,3.5c0.5,0,0.8-0.1,1-0.2C287.7,474.6,287.8,474.2,287.8,473.7z"/>
          <path class="st21" d="M336.5,463.2l-5,8c-3.4-2.3-7.3-3.5-11.8-3.5c-2.6,0-3.9,0.3-4.1,0.8c1.6,0.4,3.9,0.9,6.8,1.6
            c9.3,2.6,14,7.3,14,14.1c0,3.6-1.7,6.4-5.1,8.4c-2.7,1.6-6,2.5-9.7,2.5c-6.5,0-13-2.1-19.4-6.3l5.3-9.3c5.1,3.3,9.8,4.9,14.1,4.9
            c2.3,0,3.4-0.3,3.4-0.8c0-1.1-1.7-2-5.1-2.8c-5.2-1.3-8.6-2.3-10.3-3.2c-3.6-1.9-5.4-4.8-5.4-8.5c0-4.1,1.8-7.2,5.3-9.2
            c2.8-1.6,6.4-2.3,10.8-2.3C326.9,457.6,332.4,459.4,336.5,463.2z"/>
          <path class="st21" d="M375.2,463.2l-5,8c-3.4-2.3-7.3-3.5-11.8-3.5c-2.6,0-3.9,0.3-4.1,0.8c1.6,0.4,3.9,0.9,6.8,1.6
            c9.3,2.6,14,7.3,14,14.1c0,3.6-1.7,6.4-5.1,8.4c-2.7,1.6-6,2.5-9.7,2.5c-6.5,0-13-2.1-19.4-6.3l5.3-9.3c5.1,3.3,9.8,4.9,14.1,4.9
            c2.3,0,3.4-0.3,3.4-0.8c0-1.1-1.7-2-5.1-2.8c-5.2-1.3-8.6-2.3-10.3-3.2c-3.6-1.9-5.4-4.8-5.4-8.5c0-4.1,1.8-7.2,5.3-9.2
            c2.8-1.6,6.4-2.3,10.8-2.3C365.6,457.6,371,459.4,375.2,463.2z"/>
        </g>
      </g>
      </svg>
    </div>
    <div style="font-size:16px;">{{message}}</div>
  </div>
</template>

<script>
export default {
  name:"success",
  props: {
    message: {
      type: String,
      default:'操作成功！'
    },
  },
}
</script>
<style>
	.st0{fill:#F4A640;}
	.st1{fill:#ADCFD8;}
	.st2{fill:#55769F;}
	.st3{fill:#DAEEF7;}
	.st4{fill:#FEB546;}
	.st5{fill:#E03268;}
	.st6{fill:#FF5B7E;}
	.st7{fill:#07085B;}
	.st8{fill:#02CCC0;}
	.st9{fill:#06BFAD;}
	.st10{opacity:0.5;fill:#55769F;}
	.st11{fill:#C4DFE8;}
	.st12{fill:#FFC0BB;}
	.st13{opacity:0.6;fill:#FC8D84;}
	.st14{fill:#050645;}
	.st15{fill:#FFFFFF;}
	.st16{fill:#F99893;}
	.st17{fill:#333333;}
	.st18{fill:#6F747A;}
	.st19{fill:#CDD6E0;}
	.st20{fill:#D9D9D9;}
	.st21{fill:#3FBA0C;}
</style>


// WEBPACK FOOTER //
// src/components/states/success.vue